import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getAllAssignedSupportQueries = (queryCategory, epoch, pageSize) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.MY_QUERIES.GET_ALL_ASSIGNED_QUERIES_SUPPORT_TAB(
      queryCategory,
      epoch,
      pageSize
    ),
    "",
  );
};

export default getAllAssignedSupportQueries;
